/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Map, { Marker, Popup } from "react-map-gl/maplibre";
import "maplibre-gl/dist/maplibre-gl.css";

import MapdotPopup from "../MapdotPopup";
import Text from "../../../components/Text";
import { getConfirmStatus, CONFIRM_COLORS, CONFIRM_DICT_KEYS } from "../../../utils/confirmationStatus";
import { fixUtf8 } from "../../../utils/fixUtf8";
import siteAnalyticsService from "../../../services/siteAnalyticsService";

const BAILO_MARKER =
  "https://res.cloudinary.com/dklijqv8g/image/upload/v1624803083/bailo_marker2_bilow4.png";

class BailoMap extends Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.state = {
      selectedMapdot: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { centerLatitude, centerLongitude, zoomMap } = this.props;
    if (
      prevProps.centerLatitude !== centerLatitude ||
      prevProps.centerLongitude !== centerLongitude ||
      prevProps.zoomMap !== zoomMap
    ) {
      this.flyToCenter();
    }
  }

  flyToCenter() {
    const { centerLatitude, centerLongitude, zoomMap } = this.props;
    if (!this.mapRef.current || !centerLatitude || !centerLongitude) return;
    this.mapRef.current.getMap().flyTo({
      center: [centerLongitude, centerLatitude],
      zoom: zoomMap,
    });
  }

  render() {
    const { mapdotsTodaySearchBy, centerLatitude, centerLongitude, zoomMap } =
      this.props;

    const { dictionary } = this.props.lang;

    return (
      <div style={{ width: "100%", height: "100%" }}>
        <Map
          ref={this.mapRef}
          initialViewState={{
            longitude: centerLongitude,
            latitude: centerLatitude,
            zoom: zoomMap,
          }}
          style={{ width: "100%", height: "100%" }}
          mapStyle="https://tiles.openfreemap.org/styles/liberty"
          onLoad={() => this.flyToCenter()}
          onResize={() => this.flyToCenter()}
        >
          {mapdotsTodaySearchBy.map((mapdot) => {
            const coords = mapdot.coordinatesLatLong;
            const lat =
              coords?.Latitude || coords?.lat || coords?.latitude || null;
            const lng =
              coords?.Longitude || coords?.lng || coords?.longitude || null;

            if (!lat || !lng) return null;

            const status = getConfirmStatus(mapdot.isMapdotConfirmed);
            const dotColor = CONFIRM_COLORS[status];
            const dotTitle = dictionary[CONFIRM_DICT_KEYS[status]] || status;

            return (
              <Marker
                key={mapdot._id}
                longitude={lng}
                latitude={lat}
                anchor="bottom"
                onClick={(e) => {
                  e.originalEvent.stopPropagation();
                  if (this.props.disablePopup) return;
                  siteAnalyticsService.track({
                    eventType: "marker_click",
                    venueName: mapdot.title || mapdot.publicName || "",
                    venueId: String(mapdot._id),
                    category: mapdot.categoryIdName || null,
                  });
                  this.setState({ selectedMapdot: mapdot });
                }}
              >
                <div style={{ position: "relative", width: 35, height: 35, cursor: this.props.disablePopup ? "default" : "pointer" }}>
                  <img
                    src={BAILO_MARKER}
                    style={{ width: 35, height: 35 }}
                    alt="marker"
                  />
                  <span
                    title={dotTitle}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      background: dotColor,
                      border: "2px solid #fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                    }}
                  />
                </div>
              </Marker>
            );
          })}

          {this.state.selectedMapdot && (
            <Popup
              longitude={
                this.state.selectedMapdot.coordinatesLatLong.Longitude ||
                this.state.selectedMapdot.coordinatesLatLong.lng
              }
              latitude={
                this.state.selectedMapdot.coordinatesLatLong.Latitude ||
                this.state.selectedMapdot.coordinatesLatLong.lat
              }
              anchor="top"
              closeButton={false}
              onClose={() => this.setState({ selectedMapdot: null })}
            >
              <>
                <button
                  onClick={() => this.setState({ selectedMapdot: null })}
                  style={{
                    position: "absolute",
                    top: -13,
                    right: -13,
                    width: 26,
                    height: 26,
                    borderRadius: "50%",
                    background: "#fff",
                    border: "2px solid #222",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: 10,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                    padding: 0,
                  }}
                  aria-label="Close"
                >
                  <i className="feather icon-x" style={{ fontSize: 13, color: "#222", lineHeight: 1 }} />
                </button>
                <MapdotPopup mapdot={this.state.selectedMapdot} />

                {this.state.selectedMapdot.timeStart && (
                  <p style={{ margin: "4px 0 0", fontSize: 13, color: "#555", fontFamily: "Montserrat" }}>
                    <i className="feather icon-clock" style={{ marginRight: 5, color: "#4e6ac5", fontSize: 13 }} />
                    {dictionary.timeStart || "Start"}: {this.state.selectedMapdot.timeStart}
                  </p>
                )}

                <hr />

                <div style={{ fontFamily: "Montserrat" }}>
                  {this.state.selectedMapdot.categoryIdName !== "teacher" &&
                  this.state.selectedMapdot.categoryIdName !== "radio" &&
                  this.state.selectedMapdot.categoryIdName !== "musician"
                    ? fixUtf8(this.state.selectedMapdot.address)
                    : dictionary.addressAprox}
                  <br />
                  {fixUtf8(this.state.selectedMapdot.city)},
                  {fixUtf8(this.state.selectedMapdot.country)}
                  <br />
                  {this.state.selectedMapdot.categoryIdName === "radio" && (
                    <a
                      href={this.state.selectedMapdot.website}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {dictionary.radioWebsite}
                    </a>
                  )}
                </div>

                <br />

                <a
                  href={`https://maps.google.com?q=${
                    this.state.selectedMapdot.coordinatesLatLong.Latitude ||
                    this.state.selectedMapdot.coordinatesLatLong.lat
                  },${
                    this.state.selectedMapdot.coordinatesLatLong.Longitude ||
                    this.state.selectedMapdot.coordinatesLatLong.lng
                  }`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Text tid="goGoogle" />
                </a>
              </>
            </Popup>
          )}
        </Map>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  lang: state.lang,
  layout: state.layout,
});

export default withRouter(connect(mapStateToProps)(BailoMap));
